import React from "react";
import { GetSearchProps } from "../../../components/pages/SearchPage/queries/types/GetSearchProps";
import styled from "styled-components";
import { HierarchicalMenu, useHierarchicalMenu } from "react-instantsearch";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";
import { categoryRefinementAttributes } from "../categoryHierarchy";

interface Props {
  categories: GetSearchProps["categories"];
}
export default function CategoryFilter({ categories }: Props) {
  const { items, canRefine } = useHierarchicalMenu({ attributes: categoryRefinementAttributes });
  const hasSelectedItems = items.some(({ isRefined }) => isRefined);

  return (
    <FilterSection label="Categories" canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      <div className="t-searchFilterGroup">
        <Container>
          <HierarchicalMenu attributes={categoryRefinementAttributes} limit={20} />
        </Container>
      </div>
    </FilterSection>
  );
}

const Container = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  .ais-HierarchicalMenu-list,
  .ais-HierarchicalMenu-item {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .ais-HierarchicalMenu-link {
    font-weight: 500;
    font-size: 14px;
    color: inherit;
    line-height: 2;
    text-transform: capitalize;
    cursor: pointer;
  }
  .ais-HierarchicalMenu-count {
    display: none;
  }
  .ais-HierarchicalMenu-link--selected {
    font-weight: 700;
  }
  .ais-HierarchicalMenu-list--child .ais-HierarchicalMenu-item {
    margin-left: 10px;
  }
`;
